export function isNumeric(value: string) {
    const number = parseInt(value);
    return !isNaN(number);
}
